import ProductsContainer from '~/components/organisms/products/productsContainer';
import { QuerySetContextProvider } from '~/contexts/QuerysetContext';
import { QuerySet_State } from '~/core/state/types/state-sets.type';
import { useDynamicComponents } from '~/plugins/dynamicComponents/dynamicComponentsContext';

type CommonTemplateProps = {
    hasFulltextResults: boolean;
    categorySet: QuerySet_State[];
    productSet: QuerySet_State | undefined;
    fulltextSets: QuerySet_State[];
    showSearchOverview: boolean;
    productsTitleRef: React.RefObject<HTMLDivElement>;
};

const CommonTemplate = ({
    productSet,
    hasFulltextResults,
    categorySet,
    fulltextSets,
    productsTitleRef,
}: CommonTemplateProps) => {
    const { FulltextContainer } = useDynamicComponents();

    return (
        <>
            {productSet ? (
                <QuerySetContextProvider state={productSet} querySetId={productSet.querySet.identifier}>
                    <ProductsContainer
                        productsState={productSet}
                        categorySetState={categorySet}
                        hasFulltextResults={hasFulltextResults}
                        productsTitleRef={productsTitleRef}
                    />
                </QuerySetContextProvider>
            ) : null}
            {fulltextSets.length > 0 ? (
                <FulltextContainer
                    isInsideProducts={false}
                    isFulltextOnly={undefined === productSet && categorySet?.length === 0}
                />
            ) : null}
        </>
    );
};

export default CommonTemplate;
